import type { ChatMessage } from '@/hooks/api/useTryAssistant'

/**
 * Drop everything after an edited message. An edited tool result keeps the
 * results of sibling parallel tool calls, so every call still has its result.
 */
export function truncateAfterEdit(messages: ChatMessage[], index: number): ChatMessage[] {
  let keepUntil = index
  if (messages[index].role === 'tool') {
    while (messages[keepUntil + 1]?.role === 'tool') keepUntil++
  }
  return messages.slice(0, keepUntil + 1)
}
